/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SweetpassPaymentInfoQueryVariables = Exact<{ [key: string]: never }>;

export type SweetpassPaymentInfoQuery = {
  readonly customerPaymentInfo: {
    readonly __typename: 'CustomerPaymentInfo';
    readonly id: string;
    readonly paymentEphemeralKey: string;
    readonly paymentSessionId: string;
  };
};

export const SweetpassPaymentInfoDocument = gql`
  query SweetpassPaymentInfo {
    customerPaymentInfo {
      id
      paymentEphemeralKey
      paymentSessionId
      __typename
    }
  }
`;

export function useSweetpassPaymentInfoQuery(
  options?: Omit<Urql.UseQueryArgs<SweetpassPaymentInfoQueryVariables>, 'query'>,
) {
  return Urql.useQuery<SweetpassPaymentInfoQuery, SweetpassPaymentInfoQueryVariables>({
    query: SweetpassPaymentInfoDocument,
    ...options,
  });
}
